module.exports = __webpack_public_path__ + "fonts/iconfont.03d1b359.eot";